import { AccountInfo, AuthenticationResult, InteractionRequiredAuthError, SilentRequest } from "@azure/msal-browser";
import { loginRequest, apiRequest } from "../configs/authConfig";
import { UserRole } from "~types/types";

export interface IMsalAuthService {
  login: () => Promise<void>;
  logout: () => Promise<void>;
  getUser: () => Promise<{ userName: string, terminals: string[], role: UserRole } | null>;
  getAccessToken: () => Promise<string | null>;
  setActiveAccount: (account: AccountInfo) => Promise<void>;
}

class MsalAuthService implements IMsalAuthService {
  private activeAccount: AccountInfo | null = null;

  // We no longer manage our own MSAL instance
  // Instead, we rely on the instance provided by MsalProvider in App.tsx

  /**
   * Initiate login flow using redirect
   * Login is now handled by the MSAL React hooks - this is kept for API consistency
   */
  public async login(): Promise<void> {
    // Handled by MSAL React
  }

  /**
   * Logout user
   * Logout is now handled by the MSAL React hooks - this is kept for API consistency
   */
  public async logout(): Promise<void> {
    // Handled by MSAL React
  }

  /**
   * Set the active account
   */
  public async setActiveAccount(account: AccountInfo): Promise<void> {
    this.activeAccount = account;
  }

  /**
   * Get current authenticated user
   */
  public async getUser(): Promise<{ userName: string, terminals: string[], role: UserRole } | null> {
    if (!this.activeAccount) {
      return null;
    }

    // Here you would typically make an API call to get user details like role and terminals
    // For now we'll just return data from the account
    return {
      userName: this.activeAccount.username || this.activeAccount.name || "",
      terminals: [],
      role: UserRole.Unknown
    };
  }

  /**
   * Get access token for making API calls
   * Token acquisition is now handled via the useMsal hook
   */
  public async getAccessToken(): Promise<string | null> {
    return null;
  }
}

// Creating singleton instance
const authService = new MsalAuthService();
export default authService;